import React from 'react'
import { Image, Avatar, Checkbox, message } from 'antd'
import Icon, {
  LeftOutlined,
  StarOutlined,
  ShareAltOutlined,
  UserOutlined,
  StarFilled,
} from '@ant-design/icons'
import intl from 'react-intl-universal'
import BraftEditor from 'braft-editor'
import 'braft-editor/dist/index.css'
import { filterText, buildUUID } from '../../../utils'
import Nav from '../../../component/nav/nav'
import Banner from '../../../component/Banner/Banner'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import APagination from '../../../component/Pagination/Pagination'
import { uniqBy } from 'lodash'

import Foot from '../../../component/Foot/Foot'

import { ReactComponent as bird } from '../../../icons/bbs/bird.svg'

import forum from '../../../api/bbs'
import merchantsInfo from '../../../api/yellow'

import { BbsFilterFun } from '../components/BbsFilter/BbsFilterFun'
import wx from 'weixin-js-sdk'

import '../components/bbs.css'

import { Input, InfiniteScroll, Loading } from 'antd-mobile'

const ua = window.navigator.userAgent.toLowerCase()

export default class bbsPageDetail extends React.Component {
  constructor() {
    super()
    this.state = {
      breadArray: [
        {
          name: intl.get('KUNSHILANYISHOU'),
          path: '/main',
          navData: '1',
        },
        {
          name: intl.get('YISHOULUNT'),
          path: '/bbspages',
          navData: '2',
        },
        {
          name: intl.get('LUNTANLIEBIE'),
          path: '/bbspagelist',
          navData: '2',
        },
      ],
      totalCount: 0,
      pageNum: 1,
      pageSize: 10,
      listData: [],
      topicId: sessionStorage['BBSTOPICID'],
      collectFlag: 0,
      bbsDetail: {},
      context: BraftEditor.createEditorState(null),
      allReplyData: [],
      belongId: '',
      replyId: '',
      checkBoxValue: false,
      phoneReplyList: [],
      belongName: '',
      phoneReplyData: '',
      hasMore: true,
      UUID: '',
      phonedata: [],
      adList: [],
      verifySrc: '',
      inputverif: '',
    }
  }
  componentDidMount() {
    this.initBbsDetailData({})
    this.setState({
      UUID: buildUUID(),
    })
    this.getAds()
    this.getverifyimg()
  }

  // 获取微信参数

  getWeixinParms = async shareItem => {
    // if (ua.indexOf('micromessenger') < 0) {
    //     return false
    // }
    console.log('shareItem', shareItem)
    const weixinData = await forum.getSign({
      url: window.location.href.split('#')[0],
    })
    const weixinCurrent = await weixinData.json()
    console.log('weixinCurrent', weixinCurrent)

    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: 'wxc5cacf656994c6cc', // 必填，公众号的唯一标识
      timestamp: weixinCurrent.timestamp, // 必填，生成签名的时间戳
      nonceStr: weixinCurrent.noncestr, // 必填，生成签名的随机串
      signature: weixinCurrent.signature, // 必填，签名，见附录1
      jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    })

    wx.ready(() => {
      console.log('shareItem', shareItem)
      //分享给朋友
      wx.onMenuShareAppMessage({
        title: shareItem.mainTitle, // 分享标题
        desc: shareItem.subTitle, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
          'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户确认分享后执行的回调函数
          console.log('确认', 11111111)
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          console.log('取消', 22222222)
        },
      })

      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: shareItem.mainTitle, // 分享标题
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
          'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png', // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        },
      })
    })
  }

  inputVerify = e => {
    this.setState({
      inputverif: e.target.value,
    })
  }
  getverifyimg = () => {
    console.log('1212', 1212)
    let baseURLOBj = {
      development: process.env.REACT_APP_DEV_API,
      production: process.env.REACT_APP_PRODUCT_API,
    }
    let baseURL = baseURLOBj[process.env.NODE_ENV]
    const data = baseURL + '/website/customer/getVerify?' + Math.random()
    this.setState({
      verifySrc: data,
      inputverif: '',
    })
  }
  getAds = () => {
    merchantsInfo
      .advertisementList({})
      .then(res => res.json())
      .then(result => {
        if (result.ret === 200) {
          let apiData = result.data.filter(item => item.type === 11)
          this.setState({
            adList: apiData[0]?.path
              ? JSON.parse(apiData[0]?.path)
              : [{ firstItemUrl: '', picPath: '' }],
          })
        }
      })
  }

  handleEditorChange = context => {
    this.setState({ context })
  }

  initBbsDetailData = ({
    topicId = sessionStorage['BBSTOPICID'],
    customerId = JSON.parse(sessionStorage.getItem('USERDATA'))
      ? JSON.parse(sessionStorage.getItem('USERDATA')).customer.id
      : '',
    language = sessionStorage['language'],
    pageSize = this.state.pageSize,
    pageNum = this.state.pageNum,
  }) => {
    const { manyParams } = this.props.match.params
    sessionStorage['BBSTOPICID'] = JSON.parse(manyParams)

    console.log(JSON.parse(manyParams))
    forum
      .topicDetail({
        topicId: JSON.parse(manyParams),
        customerId,
        language,
        pageSize,
        pageNum,
      })
      .then(res => res.json())
      .then(result => {
        console.log('result', result)
        let breadObj = this.state.breadArray
        if (result.ret === 200) {
          breadObj[3] = {
            name: result.data.detail.mainTitle,
            path: '/bbspagedetail',
            navData: '2',
          }
          this.setState(
            {
              bbsDetail: result.data.detail,
              collectFlag: result.data.collectFlag,
              listData: result.data.list,
              totalCount: result.data.totalCount,
              breadArray: breadObj,
              allReplyData: result.data.list,
              belongName: result.data.detail.customerName,
              phoneReplyList: result.data.list,
            },
            () => {
              this.getverifyimg()
              this.getWeixinParms(this.state.bbsDetail)
            }
          )
        }
      })
  }

  handleFilter = () => {
    this.props.history.push('/bbspagelist')
  }

  handleChangePage = (page, pageSize) => {
    console.log(page, pageSize)
    this.setState(
      {
        pageNum: page,
        pageSize: pageSize,
      },
      () => {
        this.initBbsDetailData({})
      }
    )
  }

  handlegotosavebbs = () => {
    if (!JSON.parse(sessionStorage.getItem('USERDATA'))) {
      message.warning(intl.get('QINGXIANDENGLU'))
      return false
    }
    let saveparms = {
      topicId: sessionStorage['BBSTOPICID'],
      customerId: JSON.parse(sessionStorage.getItem('USERDATA'))
        ? JSON.parse(sessionStorage.getItem('USERDATA')).customer.id
        : '',
    }
    console.log('this.state.collectFlag ', this.state.collectFlag)
    if (this.state.collectFlag === 0) {
      forum
        .addForumCollect(
          saveparms,
          JSON.parse(sessionStorage.getItem('USERDATA')).token
        )
        .then(res => res.json())
        .then(result => {
          console.log('result', result)
          if (result.ret === 200) {
            this.setState({
              context: BraftEditor.createEditorState(null),
            })
            message.success(intl.get('SHOUCHENGCHANEG'))

            this.initBbsDetailData({})
          }
        })
    } else if (this.state.collectFlag === 1) {
      forum
        .cancelForumCollect(
          saveparms,
          JSON.parse(sessionStorage.getItem('USERDATA')).token
        )
        .then(res => res.json())
        .then(result => {
          console.log('result', result)
          if (result.ret === 200) {
            this.setState({
              context: BraftEditor.createEditorState(null),
            })
            message.success(intl.get('QUXIAOHSHOU'))
            this.initBbsDetailData({})
          }
        })
    }
  }

  judgeCollect = val => {
    if (val === 0) {
      return (
        <div className="yellow_page_detail_top_right_item">
          <div
            className="yellow_page_detail_top_right_item_icon1"
            onClick={this.handlegotosavebbs}
          ></div>
          <div
            className="bbs_page_detail_top_right_item_name customer_hover"
            onClick={this.handlegotosavebbs}
          >
            {intl.get('SHOUCAGN')}
          </div>
          <div className="bbs_page_detail_top_right_item_bottom">
            {this.state.totalCount}
            {intl.get('CIHUIFU')}
          </div>
        </div>
      )
    } else {
      return (
        <div className="yellow_page_detail_top_right_item">
          <div
            className="yellow_page_detail_top_right_item_icon3"
            onClick={this.handlegotosavebbs}
          ></div>
          <div
            className="bbs_page_detail_top_right_item_name customer_hover"
            onClick={this.handlegotosavebbs}
          >
            {intl.get('YISHOUCANG')}
          </div>
          <div className="bbs_page_detail_top_right_item_bottom">
            {this.state.totalCount}
            {intl.get('CIHUIFU')}
          </div>
        </div>
      )
    }
  }

  quoteReply = item => {
    let filterQuote = this.state.allReplyData.filter(filterItem => {
      return filterItem.id === item.replyId
    })

    if (filterQuote.length === 0) {
      return
    }
    return (
      <div className="bbs_detail_reply_right_bottom_otherreply">
        <div className="bbs_detail_reply_right_bottom_otherreply_title">
          {filterQuote[0]?.responderName} {intl.get('FABIAOYU')}
          {filterQuote[0]?.createDate}
        </div>
        <div
          className="bbs_detail_reply_right_bottom_otherreply_text"
          dangerouslySetInnerHTML={{ __html: filterQuote[0].context }}
        ></div>
      </div>
    )
  }

  reply = async ({
    belongId = this.state.belongId,
    topicId = sessionStorage['BBSTOPICID'],
    replyId = this.state.replyId,
    type = 1,
  }) => {
    if (!JSON.parse(sessionStorage.getItem('USERDATA'))) {
      message.warning(intl.get('QINGXIANDENGLU'))
      return false
    }
    let inputStr = JSON.stringify({ inputStr: this.state.inputverif })
    console.log('inputStr', inputStr)
    const verifyRes = await forum.checkVerify(
      inputStr,
      JSON.parse(sessionStorage.getItem('USERDATA')).token
    )
    const verifyRes2 = await verifyRes.json()
    if (!verifyRes2) {
      message.warning(intl.get('YANZMCUOWQU'))
      return false
    }

    console.log('this.state.inputverif', this.state.inputverif)
    switch (type) {
      case 1:
        const replyParms = {
          belongId: belongId, // 被回复楼主id
          responderId: JSON.parse(sessionStorage.getItem('USERDATA')).customer
            .id, // 回复者id
          context: filterText(this.state.context.toHTML()),
          topicId: topicId, // 主帖子id
          replyId: replyId, // 评论id
        }

        console.log('replyParms', replyParms)
        if (replyParms.context === '<p></p>') {
          message.warning(intl.get('QINGSHURUNEIRONG'))
          return false
        }

        forum
          .addForumReply(
            replyParms,
            JSON.parse(sessionStorage.getItem('USERDATA')).token,
            this.state.UUID
          )
          .then(res => res.json())
          .then(result => {
            console.log('result', result)
            if (result.ret === 200) {
              this.setState({
                context: BraftEditor.createEditorState(null),
                replyId: '',
                belongId: this.state.bbsDetail.customerId,
                UUID: buildUUID(),
                pageNum: 1,
              })
              message.success(intl.get('HUIFUCHENGGONG'))
              console.log('this.state.checkBoxValue', this.state.checkBoxValue)
              if (this.state.checkBoxValue) {
                this.setState(
                  {
                    pageNum: Math.ceil(
                      this.state.totalCount / this.state.pageSize
                    ),
                  },
                  () => {
                    this.initBbsDetailData({})
                  }
                )
              } else {
                window.scrollTo(0, 0)
                this.initBbsDetailData({})
              }
            }
          })
        break
      case 2:
        const phoneReplyParms = {
          belongId: belongId, // 被回复楼主id
          responderId: JSON.parse(sessionStorage.getItem('USERDATA')).customer
            .id, // 回复者id
          context: filterText(this.state.phoneReplyData),
          topicId: topicId, // 主帖子id
          replyId: replyId, // 评论id
        }

        console.log('phoneReplyParms', phoneReplyParms)

        phoneReplyParms.context = phoneReplyParms.context.replace(/\s/g, '')
        if (!phoneReplyParms.context) {
          message.warning(intl.get('QINGSHURUNEIRONG'))
          return false
        }

        forum
          .addForumReply(
            phoneReplyParms,
            JSON.parse(sessionStorage.getItem('USERDATA')).token,
            this.state.UUID
          )
          .then(res => res.json())
          .then(result => {
            console.log('result', result)
            if (result.ret === 200) {
              this.setState({
                phoneReplyData: '',
                replyId: '',
                belongId: this.state.bbsDetail.customerId,
                UUID: buildUUID(),
                pageNum: 1,
              })
              message.success(intl.get('HUIFUCHENGGONG'))
              if (this.state.checkBoxValue) {
                this.setState(
                  {
                    pageNum: Math.ceil(
                      this.state.totalCount / this.state.pageSize
                    ),
                  },
                  () => {
                    this.initBbsDetailData({})
                  }
                )
              } else {
                window.scrollTo(0, 0)
                this.initBbsDetailData({})
              }
            }
          })
        break
      default:
        break
    }
  }

  goDown = ({
    belongId = this.state.bbsDetail.customerId,
    replyId = '',
    belongName = this.state.bbsDetail.customerName,
    responderName,
  }) => {
    window.scrollTo(0, document.body.scrollHeight - 100)
    console.log('belongId', belongId)
    console.log('replyId', replyId)
    this.setState({
      belongId,
      replyId,
      belongName: belongName ? belongName : responderName,
    })
  }

  PhonegoDown = ({
    belongId = this.state.bbsDetail.customerId,
    replyId = '',
    belongName = this.state.bbsDetail.customerName,
    responderName,
  }) => {
    console.log('belongId', belongId)
    console.log('replyId', replyId)
    this.setState({
      belongId,
      replyId,
      belongName: belongName ? belongName : responderName,
    })
  }

  judgeGround = e => {
    if (this.state.pageNum === 1) {
      return (
        <div className="bbs_detail_reply_right_top_right">
          {e + 1}
          {intl.get('LOU')}
        </div>
      )
    }
    return (
      <div className="bbs_detail_reply_right_top_right">
        {(this.state.pageNum - 1) * this.state.pageSize + e + 1}
        {intl.get('LOU')}
      </div>
    )
  }

  changeCheckBox = e => {
    console.log('e', e)
    this.setState({
      checkBoxValue: e.target.checked,
    })
  }

  getPhoneData = e => {
    this.setState({
      phoneReplyData: e,
    })
  }

  InfiniteScrollContent = () => {
    return (
      <>
        {this.state.hasMore ? (
          <>
            <span>Loading</span>
            <Loading />
          </>
        ) : (
          <span>--- {intl.get('ZUIHOUYITIAO')} ---</span>
        )}
      </>
    )
  }

  loadMore = async () => {
    let res = await forum.topicDetail({
      topicId: sessionStorage['BBSTOPICID'],
      customerId: JSON.parse(sessionStorage.getItem('USERDATA'))
        ? JSON.parse(sessionStorage.getItem('USERDATA')).customer.id
        : '',
      language: sessionStorage['language'],
      pageSize: this.state.pageSize,
      pageNum: this.state.pageNum,
    })
    let result = await res.json()
    if (result.ret === 200 && this.state.pageNum < result.data.pageCount + 1) {
      // console.log('result.ret ===>', result.data)
      this.setState({
        pageNum: this.state.pageNum + 1,
        totalCount: result.data.totalCount,

        allReplyData: uniqBy(
          [...this.state.allReplyData, ...result.data.list],
          'id'
        ),
      })
    } else {
      this.setState({
        hasMore: false,
      })
    }
  }

  handleBack = () => {
    this.props.history.goBack()
  }

  phoneJudgeCollect = val => {
    if (val === 0) {
      return (
        <div className="phone_bbs_index_top_detail_item">
          <StarOutlined
            style={{ fontSize: '1.5rem', fontWeight: '700' }}
            onClick={this.handlegotosavebbs}
          />
          <ShareAltOutlined style={{ fontSize: '1.5rem', fontWeight: '700' }} />
        </div>
      )
    } else {
      return (
        <div className="phone_bbs_index_top_detail_item">
          <StarFilled
            style={{ fontSize: '1.5rem', fontWeight: '700' }}
            onClick={this.handlegotosavebbs}
          />
          <ShareAltOutlined style={{ fontSize: '1.5rem', fontWeight: '700' }} />
        </div>
      )
    }
  }

  handleGotoMain = () => {
    this.props.history.push({ pathname: '/main' })
  }

  handleGotoPage = val => {
    switch (val) {
      case 1:
        this.props.history.push({ pathname: '/yellowpages' })
        break
      case 2:
        this.props.history.push({ pathname: '/bbspages' })
        break
      default:
        break
    }
  }

  render() {
    document.title = this.state.bbsDetail.mainTitle
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute('content', this.state.bbsDetail.mainTitle)
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute('content', this.state.bbsDetail.mainTitle)
    document
      .querySelector('meta[itemprop="description"]')
      .setAttribute('content', this.state.bbsDetail.mainTitle)
    document
      .querySelector('meta[property="og:type"]')
      .setAttribute('content', 'website')
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute(
        'content',
        'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png'
      )
    document
      .querySelector('meta[itemprop="image"]')
      .setAttribute(
        'content',
        'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png'
      )
    document
      .querySelector('meta[itemprop="name"]')
      .setAttribute('content', this.state.bbsDetail.mainTitle)
    const controls = ['media']

    return (
      <>
        <div className="main_content">
          <Nav history={this.props.history} props={this.props} />
          <Banner
            type="2"
            history={this.props.history}
            setBannerSearch={this.handleFilter}
          />

          <div className="bbs_ads">
            <div className="bbs_ads_item">
              <a href={this.state.adList[0]?.firstItemUrl} target="_blank">
                <Image
                  width="12rem"
                  height="1.2rem"
                  preview={false}
                  src={this.state.adList[0]?.picPath}
                />
              </a>
            </div>
          </div>

          <BreadCrumb
            history={this.props.history}
            breadData={this.state.breadArray}
            style={{ paddingBottom: '0' }}
          />
          <div className="bbs_list_top">
            <div className="bbs_main_content_top_new">
              <div
                className="bbs_main_content_top_new_button"
                onClick={this.goDown}
              >
                <Icon
                  component={bird}
                  style={{ fontSize: '.16rem', paddingRight: '.12rem' }}
                  className="init-icons"
                />
                {intl.get('HUIFUTIEZI')}
              </div>
              <div className="bbs_main_content_top_new_right">
                <APagination
                  pageNum={this.state.pageNum}
                  total={this.state.totalCount}
                  current={this.state.pageNum}
                  changePage={this.handleChangePage}
                />
              </div>
            </div>
          </div>

          <div className="bbs_list_content">
            <div className="bbs_main_content_context">
              <div className="yellow_page_detail_top bbs_style">
                <div className="yellow_page_detail_top_left">
                  <div className="yellow_page_detail_top_left_title">
                    {this.state.bbsDetail.mainTitle} [
                    {this.state.allReplyData.length}]
                  </div>
                  <div className="yellow_page_detail_top_left_createtime">
                    {intl.get('ZUIJINGEGNXIN')}：
                    {this.state.bbsDetail.createDate}{' '}
                    <span className="bbs_time">
                      {intl.get('FABUSHIJINA')}：{' '}
                      {this.state.bbsDetail.createDate}
                    </span>
                  </div>
                  <div className="bbs_page_detail_top_left_bottom">
                    <div className="bbs_page_detail_top_left_bottom_item">
                      <Avatar
                        src={
                          this.state.bbsDetail.customerPath
                            ? this.state.bbsDetail.customerPath
                            : 'data:image/gif;base64,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'
                        }
                      />{' '}
                      {intl.get('LOUZHU')}：{this.state.bbsDetail.customerName}
                    </div>
                  </div>
                </div>

                <div className="yellow_page_detail_top_right">
                  {this.judgeCollect(this.state.collectFlag)}
                  <div className="yellow_page_detail_top_right_item">
                    <div className="yellow_page_detail_top_right_item_icon2"></div>
                    <div className="bbs_page_detail_top_right_item_name">
                      {intl.get('FENXIANG')}
                    </div>
                    <div className="bbs_page_detail_top_right_item_bottom">
                      {this.state.bbsDetail.clickNum}
                      {intl.get('CILIULAN')}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bbs_detail_text">
                {BbsFilterFun(this.state.bbsDetail)}
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.bbsDetail.context,
                  }}
                ></div>

                {this.state.bbsDetail.path?.split(',')?.map((item2, index2) => {
                  return (
                    <div
                      className="bbs_main_content_context_item_content_imgs_item"
                      key={index2}
                    >
                      <Image
                        preview={true}
                        src={item2}
                        fallback="data:image/png;base64,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"
                      />
                    </div>
                  )
                })}
              </div>

              {this.state.listData.map((item, index) => {
                return (
                  <div className="bbs_detail_reply" key={item.id}>
                    <div className="bbs_detail_reply_left">
                      <div className="bbs_detail_reply_left_top">
                        {intl.get('NICEHNG')}:{item.responderAcount}
                      </div>
                      <div className="bbs_detail_reply_left_bottom">
                        <div className="bbs_detail_reply_left_bottom_item">
                          <Avatar
                            size={64}
                            src={
                              item.responderPath
                                ? item.responderPath
                                : 'data:image/gif;base64,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'
                            }
                          />
                        </div>
                        <div className="bbs_detail_reply_left_bottom_item">
                          {item.responderName}
                        </div>
                        {/* <div className="bbs_detail_reply_left_bottom_item">邮箱{item.responderName}</div> */}
                      </div>
                    </div>
                    <div className="bbs_detail_reply_right">
                      <div className="bbs_detail_reply_right_top">
                        <div className="bbs_detail_reply_right_top_left">
                          {' '}
                          {intl.get('FABIAOYU')}
                          {item.createDate}
                        </div>
                        {this.judgeGround(index)}
                      </div>

                      <div className="bbs_detail_reply_right_bottom">
                        {this.quoteReply(item)}

                        <div className="bbs_detail_reply_right_bottom_content">
                          <div
                            dangerouslySetInnerHTML={{ __html: item.context }}
                          ></div>
                        </div>
                      </div>

                      <div
                        className="bbs_detail_reply_right_bottom_nail"
                        onClick={this.goDown.bind(this, {
                          belongId: item.responderId,
                          replyId: item.id,
                          belongName: item.belongName,
                          responderName: item.responderName,
                        })}
                      >
                        {intl.get('HUIFU')}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="bbs_paginon">
              <APagination
                pageNum={this.state.pageNum}
                total={this.state.totalCount}
                current={this.state.pageNum}
                changePage={this.handleChangePage}
              />
            </div>

            <div className="bbs_reply_content">
              <BraftEditor
                className="my-editor"
                controls={controls}
                placeholder={
                  intl.get('HUIFU') + ':    ' + this.state.belongName
                }
                value={this.state.context}
                onChange={this.handleEditorChange}
              />
              <div className="bbs_reply_content_bottom">
                <div
                  className="bbs_reply_content_bottom_btn"
                  onClick={this.reply.bind(this, { type: 1 })}
                >
                  {' '}
                  {intl.get('FABIAOHUIFU')}
                </div>
                <div className="bbs_reply_content_bottom_checkbox">
                  <Checkbox onChange={this.changeCheckBox}>
                    {' '}
                    {intl.get('FABIAOHOUTIAODAOZUIHOUYIYE')}
                  </Checkbox>
                </div>
                <div onClick={this.getverifyimg} className="verify_area">
                  <img
                    src={this.state.verifySrc}
                    alt="点击更换验证码"
                    height="36"
                    width="100%"
                  />
                </div>
                <div className="verify_area">
                  <input
                    value={this.state.inputverif}
                    onChange={this.inputVerify}
                  />
                </div>
              </div>
            </div>
          </div>
          <Foot history={this.props.history} />
        </div>
        {/* 移动端=========================================================================================================================================================================================================================================================================== */}

        <div className="phone_content bbs_phone_content">
          <div className="phone_bbs_index_top">
            <div className="phone_bbs_index_top_first">
              <div className="phone_bbs_index_top_first_left">
                <div className="phone_bbs_index_top_first_left_img"></div>
                <span className="phone_bbs_index_top_first_left_text">
                  {intl.get('YISHOULUNT')} {intl.get('FUWUYUAOZHOU')}
                </span>
              </div>
              <div
                className="phone_bbs_index_top_first_right"
                onClick={this.handleGotoMain}
              ></div>
            </div>
            <div className="phone_bbs_index_top_detail">
              <div
                className="phone_bbs_index_top_detail_item"
                onClick={this.handleBack}
              >
                <LeftOutlined />
              </div>
              <div className="phone_bbs_index_top_detail_item">
                {intl.get('TIEZIXIANGQING')}{' '}
              </div>

              {this.phoneJudgeCollect(this.state.collectFlag)}
            </div>

            <div className="phone_yellow_buttons">
              <div
                className="phone_yellow_buttons_item"
                onClick={this.handleGotoPage.bind(this, 1)}
              >
                {intl.get('SHANGJIAHUANG')}
              </div>
              <div
                className="phone_yellow_buttons_item"
                onClick={this.handleGotoPage.bind(this, 2)}
              >
                {intl.get('YISHOULUNT')}
              </div>
            </div>
          </div>

          <div className="phone_bbs_detail_context">
            <div className="phone_content_item_top">
              <Avatar
                size={30}
                src={
                  this.state.bbsDetail.customerPath
                    ? this.state.bbsDetail.customerPath
                    : 'data:image/gif;base64,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'
                }
              />
              <div className="phone_content_item_title">
                <div className="phone_content_item_title_text">
                  {this.state.bbsDetail.mainTitle}
                </div>
                <div className="phone_content_item_title_time">
                  {this.state.bbsDetail.customerName} --{' '}
                  {this.state.bbsDetail.createDate}
                </div>
              </div>

              <div className="phone_content_item_tag">
                <div className="phone_content_item_tag_btn_none"></div>
              </div>
            </div>

            <div className="phone_bbs_detail_context_item">
              {BbsFilterFun(this.state.bbsDetail)}

              <div
                className="phone_content_item_content"
                dangerouslySetInnerHTML={{
                  __html: this.state.bbsDetail.context,
                }}
              ></div>
              <div className="phone_content_item_imgs">
                {this.state.bbsDetail.path?.split(',')?.map((item2, index2) => {
                  return (
                    <div className="phone_content_item_imgs_item" key={index2}>
                      <Image
                        preview={true}
                        src={item2}
                        fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                      />
                    </div>
                  )
                })}
              </div>
            </div>

            <div className="phone_bbs_detail_context_comment">
              {intl.get('QUANBUPINGLUN')} （{this.state.bbsDetail.replyNum}）
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div onClick={this.getverifyimg} className="verify_area">
                <img
                  src={this.state.verifySrc}
                  alt="点击更换验证码"
                  height="36"
                  width="100%"
                />
              </div>
              <div className="verify_area">
                <input
                  value={this.state.inputverif}
                  onChange={this.inputVerify}
                />
              </div>
            </div>
            <div className="phone_bbs_detail_context_comment_send">
              <Avatar
                size={30}
                icon={<UserOutlined />}
                src={
                  JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.path
                }
              />
              <div className="phone_bbs_detail_context_comment_input">
                <Input
                  placeholder={
                    intl.get('HUIFU') + ':    ' + this.state.belongName
                  }
                  value={this.state.phoneReplyData}
                  onChange={this.getPhoneData}
                  clearable
                />
              </div>
              <div
                className="phone_bbs_detail_context_comment_btn"
                onClick={this.reply.bind(this, { type: 2 })}
              >
                {intl.get('PINGLUN')}
              </div>
            </div>

            {this.state.allReplyData.map(item => {
              return (
                <div
                  className="phone_bbs_detail_context_comment_item"
                  key={item.id}
                >
                  <div className="phone_bbs_detail_context_comment_item_info">
                    <Avatar
                      size={30}
                      icon={<UserOutlined />}
                      src={item.responderPath}
                    />
                    <div className="phone_bbs_detail_context_comment_item_info_name">
                      {item.responderName}
                    </div>
                  </div>

                  {this.quoteReply(item)}
                  <div
                    className="phone_bbs_detail_context_comment_item_text"
                    dangerouslySetInnerHTML={{ __html: item.context }}
                  ></div>
                  <div className="phone_bbs_detail_context_comment_item_action">
                    <div className="phone_content_item_title_time">
                      {item.createDate}
                    </div>
                    <div
                      className="phone_content_item_title_btn"
                      onClick={this.PhonegoDown.bind(this, {
                        belongId: item.responderId,
                        replyId: item.id,
                        belongName: item.belongName,
                        responderName: item.responderName,
                      })}
                    >
                      {intl.get('HUIFU')}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <InfiniteScroll loadMore={this.loadMore} hasMore={this.state.hasMore}>
            {this.InfiniteScrollContent()}
          </InfiniteScroll>
        </div>
      </>
    )
  }
}
